package devxertech.com.pages.services.webServices

import androidx.compose.runtime.Composable
import devxertech.com.seo.ServiceJsonLd
import devxertech.com.seo.PageMetadata
import devxertech.com.seo.PageSeo
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.commons.CommonAboutSection
import devxertech.com.pages.commons.CommonHeader
import devxertech.com.pages.commons.MakeYourOwnTeam
import devxertech.com.pages.commons.ServiceArrow
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.pages.services.webServices.serviceKeyFactor.ServiceKeySection
import devxertech.com.pages.services.webServices.structureWorkFlow.StructuredFlow
import devxertech.com.pages.services.webServices.webDesignSection.WebDesignSection
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res
import devxertech.com.utils.Res.Image.service_about

@Page ("/web-services")
@Composable
fun ServiceSection() {
    PageMetadata(PageSeo.Web)
    ServiceJsonLd("/web-services", PageSeo.Web, "Website Design and Development")
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()


    Column(
        modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)
    ) {
        CommonHeader(
            imageAlt = "Website design and development illustration",
            mainHeadingAsH1 = true,
            image = Res.Image.service_header,
            breakpoint = breakpoint,
            headingText = "Website Design and Development services",
            descriptionText = "Customized, specified and innovative solutions for website development and website design.")
        ServiceArrow("Web Design & Development")
//        ServiceAboutSection(breakpoint)
        CommonAboutSection(
            breakpoint = breakpoint,
            title = "What’s the Secret Behind",
            firstFont = "Unveiling Devxer",
            secondFont = "Web Magic Formula",
            imageName = service_about,
            description = "At Devxer Technologies, we blend innovation, strategy, and creativity to craft stunning " +
                    "digital experiences. Our expert team uses cutting-edge technology and data-driven " +
                    "insights to transform ideas into engaging, user-friendly websites. From seamless " +
                    "functionality to captivating design, we prioritize every detail to build web solutions that " +
                    "drive results and inspire users. Experience the magic of Devxer’s approach to digital excellence."
        )
        ServiceKeySection()
        StructuredFlow()
        MakeYourOwnTeam(breakpoint)
        WebDesignSection(breakpoint)
        RatingSection(breakpoint)
        HomepageFooter(breakpoint)

    }
}
